import React from 'react';
import DraggableCollectionListCard from './DraggableCollectionListCard';

/**
 * Lists within a collection
 * Uses move left/right buttons for reordering instead of drag-and-drop
 */
function CollectionListsDropZone({
  collectionId,
  lists,
  listIds,
  isReorderMode,
  onDrop,
  onListClick,
  onEditCollection,
  className = '',
}) {
  const handleMoveLeft = (e, index) => {
    e.stopPropagation();
    if (index > 0) {
      onDrop(collectionId, listIds[index], index - 1);
    }
  };

  const handleMoveRight = (e, index) => {
    e.stopPropagation();
    if (index < listIds.length - 1) {
      onDrop(collectionId, listIds[index], index + 1);
    }
  };

  if (lists.length === 0) {
    return (
      <div className="collection-empty-message">
        <p>No lists in this collection yet.</p>
        {onEditCollection && (
          <button
            className="btn-secondary"
            onClick={(e) => { e.stopPropagation(); onEditCollection(); }}
          >
            Add lists
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={`collection-lists-drop-zone ${className}`}>
      {lists.map((list, index) => (
        <div key={list.id} className="collection-list-item-wrapper">
          {/* Reorder controls */}
          {isReorderMode && (
            <div className="collection-list-reorder-controls">
              <button
                className="reorder-btn reorder-btn-left"
                onClick={(e) => handleMoveLeft(e, index)}
                disabled={index === 0}
                aria-label="Move list left"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>
              <button
                className="reorder-btn reorder-btn-right"
                onClick={(e) => handleMoveRight(e, index)}
                disabled={index === listIds.length - 1}
                aria-label="Move list right"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            </div>
          )}
          <DraggableCollectionListCard
            list={list}
            isReorderMode={isReorderMode}
            isBeingDragged={false}
            onClick={onListClick}
          />
        </div>
      ))}
    </div>
  );
}

export default CollectionListsDropZone;
